<div id="properties-popover" class="properties-panel" popover="auto"
  (beforetoggle)="onPropertiesPopoverBeforeToggle($event)">
  @if (selectedPropItem) {
  <div class="panel-header">
    <h4>Properties</h4>
    <button class="icon-button close-btn" type="button" commandfor="properties-popover" command="hide-popover"
      title="Close">
      <i class="fa fa-times"></i>
    </button>
  </div>
  <div class="item-name">{{ selectedPropItem.name }}</div>

  <div class="properties-editor">
    @if (!isEditingProperties) {
    <div>
      @if (hasCurrentProperties) {
      <div class="prop-row header">
        <span class="col-key">Key</span>
        <span class="col-val">Value</span>
      </div>
      }

      @for (key of currentProperties | keys; track key) {
      <div class="prop-row">
        <span class="col-key text-truncate" title="{{ key }}">{{ key }}</span>
        <span class="col-val text-truncate" title="{{ currentProperties[key] }}">{{ currentProperties[key] }}</span>
      </div>
      }
    </div>
    }

    @if (!hasCurrentProperties) {
    <div class="no-props">No properties defined.</div>
    }

    <div class="footer-actions mt-3 text-right">
      @if (!isViewingDiff && !isEditingProperties) {
      <button class="btn btn-sm btn-primary" (click)="enableEditMode($event)">Edit</button>
      }
    </div>

    @if (isEditingProperties) {
    <div>
      @if (hasPropertySuggestions()) {
      <div class="suggested-properties">
        <div class="suggested-properties-title">Prepopulated properties</div>
        @for (suggestion of getPropertySuggestions(); track suggestion.key) {
        <div class="suggested-property-row">
          <span class="suggested-property-key" title="{{ suggestion.key }}">{{ suggestion.key }}</span>
          @if (suggestion.values.length > 1) {
          <select class="form-control form-control-sm suggested-property-value"
            [ngModel]="propertySuggestionValues[suggestion.key] ?? suggestion.value"
            (ngModelChange)="propertySuggestionValues[suggestion.key] = $event">
            @for (value of suggestion.values; track value) {
            <option [ngValue]="value">{{ value }}</option>
            }
          </select>
          } @else {
          <span class="suggested-property-value text-truncate" title="{{ suggestion.value }}">{{ suggestion.value }}</span>
          }
          <button class="btn btn-sm btn-outline-secondary suggested-property-add" type="button"
            (click)="addSuggestedProperty(suggestion, $event)">
            <i class="fa fa-plus"></i>
          </button>
        </div>
        }
      </div>
      }

      @if (editingProperties.length > 0) {
      <div class="prop-row header">
        <span class="col-key">Key</span>
        <span class="col-val">Value</span>
        <span class="col-action"></span>
      </div>
      }
      @for (prop of editingProperties; track $index) {
      <div class="prop-row">
        <input type="text" class="form-control form-control-sm col-key" placeholder="Key" [(ngModel)]="prop.key">
        <input type="text" class="form-control form-control-sm col-val" placeholder="Value" [(ngModel)]="prop.value">
        <span class="col-action">
          <i class="fa fa-trash text-danger" (click)="removeProperty($index, $event)" title="Remove Property"></i>
        </span>
      </div>
      }

      <div class="actions mt-2">
        <button class="btn btn-sm btn-outline-secondary" (click)="addProperty()">
          <i class="fa fa-plus"></i> Add Property
        </button>
      </div>

      <div class="footer-actions mt-3 text-right">
        <button class="btn btn-sm btn-secondary mr-2" (click)="cancelProperties($event)">Cancel</button>
        <button class="btn btn-sm btn-primary" (click)="saveProperties()">Save</button>
      </div>
    </div>
    }
  </div>
  }
</div>
